import React from 'react';
import { ShieldAlert } from 'lucide-react';

export interface ClinicalSafetyNoticeProps {
  /** Override the default medication wording (keep it free of patient data). */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Clinical-safety notice (ASM-09, MED-05). Static text only: it never shows patient data.
 * Tells clinicians the record is not a decision-support tool.
 */
const ClinicalSafetyNotice: React.FC<ClinicalSafetyNoticeProps> = ({ children, className = '' }) => (
  <div
    role="note"
    data-testid="clinical-safety-notice"
    className={`flex items-start gap-2 rounded-md border border-slate-300 bg-slate-50 px-3 py-2 text-xs text-slate-700 ${className}`}
  >
    <ShieldAlert size={16} className="mt-0.5 flex-shrink-0 text-slate-500" aria-hidden="true" />
    <p className="text-left">
      {children ?? (
        <>
          Pelora does not check drug interactions, allergies against medications, or doses. Confirm every
          medication, dose and route against the physician&apos;s order and a current drug reference before
          giving it.
        </>
      )}
    </p>
  </div>
);

export default ClinicalSafetyNotice;
